import Vue from 'vue';
import Router from 'vue-router';
const originalPush = Router.prototype.push;

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const Manage = () => import( '../views/manage/manage.vue');
const volumeList = () => import( '../views/volume/list/list.vue'); //云盘列表
const create = () => import( '../views/volume/create/createVolume.vue'); //新建云盘
const dbscVolumeCreate = () => import( '../views/volume/dbscVolumeCreate/dbscVolumeCreate.vue'); //新建dbsc云盘
const detail = () => import('../views/volume/detail/detail.vue');//云盘详情
const unService = () => import('../views/snapshot/unService.vue');//未开通快照服务
const snapshotList = () => import('../views/snapshot/snapshotList/snapshotList.vue');//快照列表
const recycle = () => import('../views/volume/recycle/recycle.vue');//云盘回收站列表
const dbscList = () => import('../views/dbsc/list/dbscList.vue');
const dbscCreate = () => import('../views/dbsc/create/dbscCreate.vue');
const dbscDetail = () => import('../views/dbsc/detail/dbscDetail.vue');
const dbscDetailInfo = () => import('../views/dbsc/detail/dbscDetailInfo/dbscDetailInfo.vue');
const dbscDetailVolume = () => import('../views/dbsc/detail/dbscDetailVolume/dbscDetailVolume.vue');
const dbscMonitor = () => import('../views/dbsc/detail/dbscMonitor/dbscMonitor.vue');
const dbscUnService = () => import('../views/dbsc/dbscUnService.vue');

Vue.use(Router);
export default new Router({
    routes:[
        {
            path:'/',
            // name: 'default',
            redirect:'/volume/list'
            // component: volumeList

        },
        {
            path: '/manage',
            name: 'manage',
            component: Manage,
            redirect:'/manage/volume/list',
            children: [
                {
                    path: '/manage/volume/list',
                    name: 'manageVolumeList',
                    component: volumeList
                },
                {
                    path: '/manage/volume/snapshot',
                    component: snapshotList
                },
                {
                    path: '/manage/dbsc/list',
                    name: 'dbscList',
                    component: dbscList
                },
                {
                    path: '/manage/recycle',
                    name: 'manageRecycle',
                    component: recycle
                }
            ]
        },
        {
            path: '/volume/list',
            name: 'volumeList',
            component: volumeList
        },
        {
            path: '/volume/create',
            name: 'create',
            component: create
        },
        {
            path: '/volume/dbscVolumeCreate',
            name: 'dbscVolumeCreate',
            component: dbscVolumeCreate
        },
        {
            path: '/volume/detail',
            name: 'detail',
            component: detail 
        },
        {
            path: '/snapshot/unService',
            name: 'unService',
            component: unService 
        },
        {
            path: '/snapshot/list',
            name: 'snapshotList',
            component: snapshotList 
        },
        {
            path: '/volume/recycle',
            name: 'recycle',
            component: recycle 
        },
        {
            path: '/dbsc/create',
            name: 'dbscCreate',
            component: dbscCreate
        },
        {
            path: '/dbsc/unService',
            name: 'dbscUnService',
            component: dbscUnService
        },
        {
            path: '/dbsc/detail',
            name: 'dbscDetail',
            component: dbscDetail,
            children: [
                {
                    path: '/dbsc/detail/info',
                    name: 'dbscDetailInfo',
                    component: dbscDetailInfo
                },
                {
                    path: '/dbsc/detail/volume',
                    name: 'dbscDetailVolume',
                    component: volumeList
                },
                {
                    path: '/dbsc/detail/snapshot',
                    name: 'dbscDetailSnapshot',
                    component: snapshotList
                },
                {
                    path: '/dbsc/detail/monitor',
                    name: 'dbscMonitor',
                    component: dbscMonitor
                }
            ]
        }
    ]
});
  
  